import { TextField, Typography } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';

import {
  AgendamentoStatusTypes,
  AgendamentoStatusValues,
} from 'store/reducers/agendamentos';

type StatusOption = {
  value: AgendamentoStatusTypes;
  label: string;
};

const statusOptions: StatusOption[] = Object.entries(
  AgendamentoStatusValues,
).map(([key, label]) => ({ value: key as AgendamentoStatusTypes, label }));

interface StatusSelectFieldProps {
  value: AgendamentoStatusTypes | '';
  style?: React.CSSProperties;
  onFilter: (status: AgendamentoStatusTypes) => void;
  onReset: () => void;
}

export default function StatusSelectField({
  value,
  style,
  onFilter,
  onReset,
}: StatusSelectFieldProps) {
  const selectedOption = statusOptions.find(o => o.value === value) ?? null;

  const handleChange = (
    _event: React.ChangeEvent<Record<string, unknown>>,
    option: StatusOption | null,
  ) => {
    if (option) {
      onFilter(option.value);
    } else {
      onReset();
    }
  };

  return (
    <Autocomplete
      id="status-select-field"
      value={selectedOption}
      options={statusOptions}
      size="small"
      onChange={handleChange}
      popupIcon={<ExpandMore style={{ fontSize: 18 }} />}
      closeText="Fechar"
      openText="Abrir"
      clearText="Limpar"
      getOptionLabel={option => option.label}
      getOptionSelected={(option, value) => option.value === value.value}
      noOptionsText={
        <Typography variant="body2">Nenhum status encontrado</Typography>
      }
      style={{ minWidth: 150, width: '100%', ...style }}
      renderOption={option => option.label}
      renderInput={params => (
        <TextField
          {...params}
          label="Status"
          variant="outlined"
          placeholder="Buscar status..."
        />
      )}
    />
  );
}
